import React, { useEffect, useState } from 'react';

const themes = [
	{
		label: 'Light',
		value: '',
		icon: (
			<svg
				width="20"
				height="20"
				fill="none"
				viewBox="0 0 24 24"
				stroke="currentColor"
			>
				<circle cx="12" cy="12" r="5" strokeWidth="2" />
				<path
					strokeWidth="2"
					d="M12 1v2m0 18v2m11-11h-2M3 12H1m16.95 7.07l-1.41-1.41M6.34 6.34L4.93 4.93m12.02 0l-1.41 1.41M6.34 17.66l-1.41 1.41"
				/>
			</svg>
		),
	},
	{
		label: 'Dark',
		value: 'dark',
		icon: (
			<svg
				width="20"
				height="20"
				fill="none"
				viewBox="0 0 24 24"
				stroke="currentColor"
			>
				<path
					strokeWidth="2"
					d="M21 12.79A9 9 0 1111.21 3a7 7 0 109.79 9.79z"
				/>
			</svg>
		),
	},
	{
		label: 'Colorful',
		value: 'colorful',
		icon: (
			<svg
				width="20"
				height="20"
				fill="none"
				viewBox="0 0 24 24"
				stroke="currentColor"
			>
				<circle cx="12" cy="12" r="10" strokeWidth="2" />
				<path strokeWidth="2" d="M12 2v20M2 12h20" />
			</svg>
		),
	},
];

const ThemeSwitcher = () => {
	const [theme, setTheme] = useState('');

	useEffect(() => {
		if (theme) {
			document.body.setAttribute('data-theme', theme);
		} else {
			document.body.removeAttribute('data-theme');
		}
	}, [theme]);

	return (
		<div className="flex items-center gap-2">
			{themes.map((t) => (
				<button
					key={t.value}
					className={`p-2 rounded-full border transition-colors duration-200 flex items-center justify-center text-xl ${
						theme === t.value
							? 'bg-primary text-white border-primary'
							: 'bg-bg text-text border-primary/40 hover:bg-primary/10'
					}`}
					onClick={() => setTheme(t.value)}
					aria-label={t.label}
				>
					{t.icon}
				</button>
			))}
		</div>
	);
};

export default ThemeSwitcher;
